import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick", "disabled"]
const _hoisted_2 = {
  class: "disk__rename_dialog",
  tabindex: "0"
}
const _hoisted_3 = { class: "disk__rename_dialog-content" }
const _hoisted_4 = { class: "disk__rename_dialog-rename" }
const _hoisted_5 = { class: "disk__rename_dialog-rename-head" }
const _hoisted_6 = { class: "disk__rename_dialog-rename-body" }
const _hoisted_7 = ["onFocusin", "onFocusout"]
const _hoisted_8 = ["name", "value"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["placeholder", "maxlength"]
const _hoisted_11 = { class: "disk__rename_dialog-rename-footer" }

import { onMounted, ref, reactive, computed } from 'vue'
import { usePromisifyDialog } from '@shared/utils/dialog'

type TForm = {
  name: string
  label: string
  placeholder?: string
  hasClearIcon?: boolean
  defaultValue?: string
}
interface IProps {
  title?: string
  maskClosable?: boolean
  defaultValue?: string
  isBuiltIn?: boolean
  isSelect?: boolean
  callback: (newName: string | { [key: string]: { value: string } }) => void
  placeholder?: string
  hasClearIcon?: boolean
  maxlength?:number
  form?: TForm[]
}

interface IEmit {
  (e: 'dialog-close'): void
}

interface IInputFileEvent extends Event {
  target: HTMLInputElement
}


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    maskClosable: { type: Boolean },
    defaultValue: null,
    isBuiltIn: { type: Boolean },
    isSelect: { type: Boolean },
    callback: null,
    placeholder: null,
    hasClearIcon: { type: Boolean },
    maxlength: null,
    form: null
  },
  emits: ["dialog-close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'dialog-close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  title?: string
  maskClosable?: boolean
  defaultValue?: string
  isBuiltIn?: boolean
  isSelect?: boolean
  callback: (newName: string | { [key: string]: { value: string } }) => void
  placeholder?: string
  hasClearIcon?: boolean
  maxlength?:number
  form?: TForm[]
}




const isMountedRef = ref(false)
const nextCallback = ref()
const inputEleRef = ref(null)
const inputValue = ref(props?.defaultValue)
const form = props?.form ? reactive(props?.form?.reduce((result, item) => {
  console.log('form', item.name, item.defaultValue)
  result[item.name] = item
  result[item.name].value = item.defaultValue || ''
  result[item.name].ref = ref(null)
  result[item.name].focus = ref(false)
  result[item.name].setRef = el => {
    if (el) result[item.name].ref = el
  }
  return result
}, {})) : null

const disabled = computed(() => {
  if (form) {
    let isModify = true
    for (let name in form) {
      const item = form[name]
      if (!item.value) {
        isModify = true
        break
      } else if (item.value !== item.defaultValue) {
        isModify = false
      }
    }
    return isModify
  } else {
    return !inputValue.value?.length || inputValue.value === props?.defaultValue
  }
})
let timer

const { close } = usePromisifyDialog(emit)

const handleClose = () => {
  isMountedRef.value = false
  timer && clearInterval(timer)
  setTimeout(() => {
    close(null)
  }, 300)
}

const handleOnFormInput = (evt: IInputFileEvent) => {
  let { name, value } = evt.target
  value = value.trim()
  if (name === 'password') value = value.replace(/[\u4e00-\u9fa5]/g, '')
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (form && form[name]) form[name].value = value
}

const preHandle = (callback: Function, isSelect: boolean) => {
  nextCallback.value = callback
  const ref = props.form && form ? form[props.form[0].name].ref : inputEleRef.value
  console.log('ref', ref)
  if (isSelect) {
    ref.focus()
    setTimeout(() => {
      if (ref) {
        ref.select()
      }
    }, 100)
  }
}

const handleCleanInput = () => {
  inputValue.value = ''
}

const handleOnRename = async () => {
  if (typeof nextCallback.value === 'function') {
    const ret = nextCallback.value(form || inputValue.value)
    if (ret instanceof Promise) {
      const returnVal = await ret
      if (returnVal) handleClose()
    }
  } else {
    handleClose()
  }
}

onMounted(() => {
  if (props.callback) {
    preHandle(props.callback, !!props.isSelect)
  }

  setTimeout(() => {
    isMountedRef.value = true
  }, 0)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass(["pop-wrapper pop-wrapper-as", { 'is-mounted': isMountedRef.value }]),
      onClick: _withModifiers(handleClose, ["self"]),
      disabled: !props.maskClosable
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", { onClick: handleClose }, "取消"),
              _createElementVNode("h3", null, _toDisplayString(props.title || '重命名'), 1),
              _createElementVNode("span", {
                onClick: handleOnRename,
                class: _normalizeClass({ disabled: _unref(disabled) })
              }, "完成", 2)
            ]),
            _createElementVNode("div", _hoisted_6, [
              (props.form && _unref(form))
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.form, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.name,
                      class: _normalizeClass(["disk__rename_dialog-rename-form", { focused: !_unref(form)[item.name].focus && !_unref(form)[item.name].value }])
                    }, [
                      _createElementVNode("label", null, _toDisplayString(!_unref(form)[item.name].focus && !_unref(form)[item.name].value ? item.placeholder : item.label), 1),
                      _createElementVNode("div", {
                        onFocusin: ($event: any) => (_unref(form)[item.name].focus = true),
                        onFocusout: ($event: any) => (_unref(form)[item.name].focus = false)
                      }, [
                        _createElementVNode("input", {
                          name: item.name,
                          value: _unref(form)[item.name].value,
                          onInput: handleOnFormInput,
                          ref_for: true,
                          ref: _unref(form)[item.name].setRef,
                          autocomplete: "off"
                        }, null, 40, _hoisted_8),
                        (_unref(form)[item.name].value?.length && item.hasClearIcon)
                          ? (_openBlock(), _createElementBlock("i", {
                              key: 0,
                              onClick: ($event: any) => (_unref(form)[item.name].value = '')
                            }, null, 8, _hoisted_9))
                          : _createCommentVNode("", true)
                      ], 40, _hoisted_7)
                    ], 2))
                  }), 128))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
                      ref_key: "inputEleRef",
                      ref: inputEleRef,
                      placeholder: props.placeholder || '请输入',
                      maxlength: props.maxlength,
                      autocomplete: "off"
                    }, null, 8, _hoisted_10), [
                      [_vModelText, inputValue.value]
                    ]),
                    (inputValue.value?.length && props.hasClearIcon)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          onClick: handleCleanInput
                        }))
                      : _createCommentVNode("", true)
                  ], 64))
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", { onClick: handleClose }, "取消"),
              _createElementVNode("span", {
                onClick: handleOnRename,
                class: _normalizeClass({ disabled: _unref(disabled) })
              }, "完成", 2)
            ])
          ])
        ])
      ])
    ], 10, _hoisted_1)
  ]))
}
}

})